export const LOGIN_URL = '/login'

export const PERMISSIONS = {
  ALLOW_READ_COMPETITIONS: 'allow-read-competitions',
  ALLOW_WRITE_COMPETITIONS: 'allow-write-competitions',
  ALLOW_READ_COMPETITORS: 'allow-read-competitors',
  ALLOW_WRITE_COMPETITORS: 'allow-write-competitors',
  ALLOW_READ_EVENTS: 'allow-read-events',
  ALLOW_WRITE_EVENTS: 'allow-write-events',
  ALLOW_READ_LEAGUES: 'allow-read-leagues',
  ALLOW_WRITE_LEAGUES: 'allow-write-leagues',
  ALLOW_READ_LOCATION: 'allow-read-location',
  ALLOW_READ_MATCH_CENTER: 'allow-read-match-center',
  ALLOW_WRITE_MATCH_CENTER: 'allow-write-match-center',
  ALLOW_READ_ODDS_CENTER: 'allow-read-odds-center',
  ALLOW_WRITE_ODDS_CENTER: 'allow-write-odds-center',
  ALLOW_READ_PLAYERS: 'allow-read-players',
  ALLOW_WRITE_PLAYERS: 'allow-write-players',
  ALLOW_READ_PREDICTION_TABLE: 'allow-read-prediction-table',
  ALLOW_WRITE_PREDICTION_TABLE: 'allow-write-prediction-table',
  ALLOW_READ_PROJECTS: 'allow-read-projects',
  ALLOW_WRITE_PROJECTS: 'allow-write-projects',
  ALLOW_READ_SPORTS: 'allow-read-sports',
  ALLOW_WRITE_SPORTS: 'allow-write-sports',
  ALLOW_READ_STATISTICS: 'allow-read-statistics',
  ALLOW_WRITE_STATISTICS: 'allow-write-statistics',
  ALLOW_READ_USERS: 'allow-read-users',
  ALLOW_WRITE_USERS: 'allow-write-users',
  ALLOW_READ_VENUES: 'allow-read-venues',
  ALLOW_WRITE_VENUES: 'allow-write-venues',
  ALLOW_READ_COUNTRIES: 'allow-read-countries',
  ALLOW_WRITE_COUNTRIES: 'allow-write-countries',
};

export const SPORTS = {
  CRICKET: 'cricket',
  FOOTBALL: 'football',
  KABADDI: 'kabaddi',
  TENNIS: 'tennis',
  BASKETBALL: 'basketball',
};

export const APIS = {
  PARIMATCH: 'Parimatch',
  SPORTSRADAR: 'SportsRadar',
  SPORTSRAPI: 'SportsApi',
  SPORTROANUZ: 'SportRoanuz',
  BLASKAPI: 'BlaskApi',
  LSPORTS: 'LSports',
  INTERNAL: 'Internal',
};

export const INTERNAL_MANAGE_TYPES = {
  LEAGUES: 'Leagues',
  COMPETITIONS: 'Competitions',
  MATCHES: 'Matches',
  TEAMS: 'Teams',
};

export const API_CALL_STATUS = {
  PENDING: 'Pending',
  SUCCESS: 'Success',
  FAILED: 'Failed',
  CANCELED: 'Canceled'
};

export const MATCH_RESPONSE_STATUS = {
  INPROGRESS: 'InProgress',
  FINISHED: 'Finished',
  FAILED: 'Failed',
};

export const COLORS_BY_STATUS = {
  [API_CALL_STATUS.PENDING]: 'grey',
  [API_CALL_STATUS.SUCCESS]: 'green',
  [API_CALL_STATUS.FAILED]: 'red',
  [API_CALL_STATUS.CANCELED]: 'red',
};

export const MORE_ROUTES = [
  {
    title: 'Users',
    to: "/users",
    permissions: PERMISSIONS.ALLOW_READ_USERS
  },
  {
    title: 'Countries',
    to: "/countries",
    permissions: PERMISSIONS.ALLOW_READ_COUNTRIES
  },
  {
    title: 'Competitions',
    to: "/competitions",
    permissions: PERMISSIONS.ALLOW_WRITE_COMPETITIONS
  },
  {
    title: 'Leagues',
    to: "/leagues",
    permissions: PERMISSIONS.ALLOW_WRITE_LEAGUES
  },
  {
    title: 'Teams & Players',
    to: "/teams-and-players",
    permissions: [PERMISSIONS.ALLOW_READ_COMPETITORS, PERMISSIONS.ALLOW_READ_PLAYERS]
  },
  {
    title: 'Venues',
    to: "/venues",
    permissions: PERMISSIONS.ALLOW_READ_VENUES
  },
  {
    title: 'Manage internal',
    to: "/manage-internal-data",
    permissions: [PERMISSIONS.ALLOW_READ_COMPETITORS, PERMISSIONS.ALLOW_READ_EVENTS, PERMISSIONS.ALLOW_READ_COMPETITIONS, PERMISSIONS.ALLOW_READ_LEAGUES],
    anyPermission: true
  },
  {
    title: 'Manage projects',
    to: "/manage-projects",
    permissions: PERMISSIONS.ALLOW_WRITE_PROJECTS,
    anyPermission: true
  },
]